import React from 'react';
import { connect } from 'react-redux';
import {
    BodyLargeRegular,
    Button,
    CrossIcon,
    DisplayExtraSmall,
    Input,
    Item,
    Label,
    ModalHeader,
    Multiselect,
} from 'prospect-path-base';
import createProductForTeam from '../../../actions/product-management/CreateProductForTeam';

class NewProduct extends React.Component
{
  constructor(props) {
    super(props);

    this.state = {
      newProduct: {
        name: '',
        categories: [],
        supported_regions: [],
      },
      noCategoriesError: false,
    };

    this.setNewProductName = this.setNewProductName.bind(this);
    this.setNewProductCategories = this.setNewProductCategories.bind(this);
    this.setNewProductSupportedRegions = this.setNewProductSupportedRegions.bind(this);
    this.addProduct = this.addProduct.bind(this);
  }
  setNewProductName(event) {
    this.setState({
      newProduct: {
        ...this.state.newProduct,
        name: event.target.value,
      }
    })
  }
  setNewProductCategories(categories) {
    this.setState({
      newProduct: {
        ...this.state.newProduct,
        categories,
      }
    })
  }
  setNewProductSupportedRegions(supported_regions) {
    this.setState({
      newProduct: {
        ...this.state.newProduct,
        supported_regions,
      }
    })
  }
  addProduct() {
    // If there are no categories show an error and don't update the product
    if (this.state.newProduct.categories.length === 0) {
      this.setState({
        noCategoriesError: true,
      });
      return;
    } else {
      this.setState({
        noCategoriesError: false,
      });
    }

    this.props.createProductForTeam(
      this.props.teamId,
      this.state.newProduct,
    );

    this.props.setStep('ProductSuccess');
  }
  render() {
    return (
      <div>
        <ModalHeader
          title={(
            <div>
              <DisplayExtraSmall>New product</DisplayExtraSmall>
              <BodyLargeRegular>Please provide some basic product details</BodyLargeRegular>
            </div>
          )}
          close={<CrossIcon onClick={this.props.closeProductModal} />}
        />

        <Item>
          <Label htmlFor="name">Product name</Label>
          <Input id="name" value={this.state.newProduct.name} onChange={this.setNewProductName} />
        </Item>

        <Item
          error={this.state.noCategoriesError ? 'The product must have at least one category' : ''}
        >
          <Label htmlFor="category">Categories</Label>
          <Multiselect
            options={[
              {
                label: "Categories",
                options: this.props.categories.map(category => ({
                  label: category.name,
                  value: category.id,
                })),
              },
            ]}
            onChange={this.setNewProductCategories}
            initialValues={this.state.newProduct.categories}
          />
        </Item>

        {/*<Item hint="Where can you support customers of this product?">*/}
        {/*  <Label htmlFor="regions">Supported regions</Label>*/}
        {/*  <Multiselect*/}
        {/*    options={[*/}
        {/*      {value: 'Africa'},*/}
        {/*      {value: 'Asia'},*/}
        {/*      {value: 'Europe'},*/}
        {/*      {value: 'North America'},*/}
        {/*      {value: 'Australia/Oceania'},*/}
        {/*      {value: 'South America'},*/}
        {/*    ]}*/}
        {/*    labelKey="value"*/}
        {/*    valueKey="value"*/}
        {/*    multiple={true}*/}
        {/*    render={(props) => {*/}
        {/*      return (*/}
        {/*        <MultiselectItem key={props.item[props.valueKey]} {...props} />*/}
        {/*      );*/}
        {/*    }}*/}
        {/*    value={this.state.newProduct.supported_regions}*/}
        {/*    onChange={this.setNewProductSupportedRegions}*/}
        {/*  />*/}
        {/*</Item>*/}

        <div style={{ display: 'flex' }}>
          { this.props.showBack &&
              <Button
                style={{ width: '25%', marginRight: '0.75rem' }}
                block
                color="secondary"
                onClick={() => this.props.setStep('ShowExistingProducts')}
              >
                Back
              </Button>
          }
          <Button
            block
            onClick={this.addProduct}
          >
            Add product
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  categories: state.productManagement.categories.all,
});

const mapDispatchToProps = dispatch => ({
  createProductForTeam: (teamId, productData) => dispatch(createProductForTeam(teamId, productData))
});

export default connect(mapStateToProps, mapDispatchToProps)(NewProduct);
